const SOUND_KEY = 'cd-notif-sound';

let audioCtx: AudioContext | null = null;
let unlocked = false;

export function isNotificationSoundEnabled(): boolean {
  try {
    return localStorage.getItem(SOUND_KEY) !== '0';
  } catch {
    return true;
  }
}

export function setNotificationSoundEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(SOUND_KEY, enabled ? '1' : '0');
  } catch {
    // ignore quota / private mode
  }
}

export function unlockNotificationAudio(): void {
  if (unlocked) {
    return;
  }
  const ctx = getAudioContext();
  if (!ctx) {
    return;
  }
  if (ctx.state === 'suspended') {
    void ctx.resume();
  }
  unlocked = true;
}

export function playNotificationSound(): void {
  if (!isNotificationSoundEnabled()) {
    return;
  }

  const ctx = getAudioContext();
  if (!ctx) {
    return;
  }

  if (ctx.state === 'suspended') {
    void ctx.resume();
  }

  const now = ctx.currentTime;
  const gain = ctx.createGain();
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.08, now + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.42);
  gain.connect(ctx.destination);

  const first = ctx.createOscillator();
  first.type = 'sine';
  first.frequency.setValueAtTime(880, now);
  first.connect(gain);
  first.start(now);
  first.stop(now + 0.16);

  const second = ctx.createOscillator();
  second.type = 'sine';
  second.frequency.setValueAtTime(1174.7, now + 0.12);
  second.connect(gain);
  second.start(now + 0.12);
  second.stop(now + 0.36);
}

function getAudioContext(): AudioContext | null {
  const Ctor =
    window.AudioContext ||
    (window as Window & {webkitAudioContext?: typeof AudioContext})
      .webkitAudioContext;
  if (!Ctor) {
    return null;
  }
  if (!audioCtx) {
    audioCtx = new Ctor();
  }
  return audioCtx;
}
